<template>
	<div class="tt_main tt_login">
		<div class="tt_box">
			<div class="tt_clo"><span class="tconfont tt-close" @click="handleClose"></span></div>
			<div class="tt_login_top">
				<img src="@/assets/images/logo.png" />
				<i></i>
				<span>{{ t('login.dengru') }}</span>
			</div>
			<div class="tt_login_main">
				<div class="tt_login_tit">
					<div class="t">{{ t('login.dengluyihuode') }}</div>
					<!-- <div class="m">
						{{ t('login.haimeiyouzhanghu') }}
						<a href="javascript:void(0)" class="blue" @click="handleImmediateRegister">{{ t('login.lijizhuce') }}</a>
					</div> -->
				</div>
				<div id="loginform">
					<div class="main_form">
						<div class="item item_full" :class="loginFormVo.usernameError ? 'error' : ''">
							<div class="tit">{{ t('login.zhanghao') }}</div>
							<div class="con">
								<input v-model="loginFormVo.username" type="text" class="input" :placeholder="t('home.qingshuru') + t('login.zhanghao')" @input="formVerifyError(false, 'username')" />
							</div>
							<em v-if="loginFormVo.usernameError" for="account" class="error">{{ t('login.cixiangweibitianxiang') }}</em>
						</div>
						<div class="item item_full" :class="loginFormVo.passwordError ? 'error' : ''">
							<div class="tit">{{ t('login.mima') }}</div>
							<div class="con">
								<input
									v-model="loginFormVo.password"
									:type="loginHeaderRef.passwordType"
									class="input"
									:placeholder="t('home.qingshuru') + t('login.mima')"
									@input="formVerifyError(false, 'password')"
								/>
								<span class="view" :class="loginHeaderRef.isViews ? 'views' : ''" @click="handleViews"></span>
							</div>
							<em v-if="loginFormVo.passwordError" for="password" class="error">{{ t('login.cixiangweibitianxiang') }}</em>
						</div>
						<div class="tt_box_btn login_btnbox">
							<button class="btn btn1" @click="handleGoLogin">{{ t('home.denglu') }}</button>
							<a href="javascript:void(0)" class="btn btn2" @click="handleGuestLogin">{{ t('login.yikerenshenfen') }}</a>
						</div>
					</div>
					<div class="tt_login_foot">
						<a href="javascript:void(0)" class="blue" @click="handleImmediateRegister">{{ t('login.zhuce') }}</a>
					</div>
					<div class="tt_login_checkbox">
						<div class="list_checkbox">
							<label>
								<input v-model="loginFormVo.isSelectProtocol" type="checkbox" :class="loginFormVo.isSelectProtocolError ? 'error' : ''" checked @change="formVerifyError(false, 'protocol')" />
								<p></p>
							</label>
						</div>
						<div class="con">
							{{ t('login.xuanzebeishiwei') }} {{ loginHeaderRef.hostUrl }}
							<a href="javascript:void(0)" @click="handleTerm(true)">{{ t('login.tiaokuan') }}</a>
							{{ t('login.yiji') }}
							<a href="javascript:void(0)" @click="handlePolicy(true)">{{ t('login.yinsishengming') }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bg" @click="handleClose"></div>
		<el-dialog v-model="isShowPolicyContent" destroy-on-close :z-index="99999989" lock-scroll modal :align-center="true" :header="null">
			<policy-content></policy-content>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="handlePolicy(false)">{{ t('addPsg.queren') }}</el-button>
				</div>
			</template>
		</el-dialog>
		<el-dialog v-model="isShowTermContent" destroy-on-close :z-index="99999989" :align-center="true">
			<term-service></term-service>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="handleTerm(false)">{{ t('addPsg.queren') }}</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script lang="ts" setup>
import { reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { HeaderNewLoginForm, NewHeaderLoginRef } from '@/logic/header/model/index';
import { memberLoginAoFun, memberGuestLoginFun } from '@/logic/header/index';
import { useMessage } from '@/components/Message/index'; // 自定义封装的message
import { useNuxtApp } from 'nuxt/app';
const { t } = useI18n();
const { $eventBus } = useNuxtApp();
const currentSource = ref('');
const loginHeaderRef = reactive(new NewHeaderLoginRef());
const loginFormVo = reactive(new HeaderNewLoginForm());
const isShowPolicyContent = ref(false);
const isShowTermContent = ref(false);
const emits = defineEmits(['closeLoginPop', 'immediateRegister']);
function handleClose() {
	emits('closeLoginPop');
}
function handleTerm(isShow: boolean) {
	isShowTermContent.value = isShow;
}
function handlePolicy(isShow: boolean) {
	isShowPolicyContent.value = isShow;
}

function handleImmediateRegister() {
	emits('closeLoginPop');
	emits('immediateRegister');
}
async function handleGuestLogin() {
	let { token } = await memberGuestLoginFun();
	if (token) {
		handleClose();
		setTimeout(() => {
			if (currentSource.value === 'verifyPrice') {
				// @ts-ignore
				$eventBus.emit('jumpSearchDetail');
			}
		}, 1000);
	}
}

async function handleGoLogin() {
	if (formVerifyError(true, 'login')) {
		let { token } = await memberLoginAoFun(loginFormVo.username, loginFormVo.password);
		if (token) {
			handleClose();
			setTimeout(() => {
				if (currentSource.value === 'verifyPrice') {
					// @ts-ignore
					$eventBus.emit('jumpSearchDetail');
				}
			}, 1000);
			useMessage().success(t('login.dengluchenggong'));
		}
	}
}
function formVerifyError(showProtocolToast: boolean, type: string) {
	let haveError: boolean = false;
	// loginFormVo.usernameError = false;
	// loginFormVo.passwordError = false;
	// loginFormVo.isSelectProtocolError = false;
	if (type === 'login' || type === 'username') {
		if (!loginFormVo.username) {
			loginFormVo.usernameError = true;
			haveError = true;
		} else {
			loginFormVo.usernameError = false;
		}
	}
	if (type === 'login' || type === 'password') {
		if (!loginFormVo.password) {
			loginFormVo.passwordError = true;
			haveError = true;
		} else {
			loginFormVo.passwordError = false;
		}
	}
	if (type === 'login' || type === 'protocol') {
		if (!loginFormVo.isSelectProtocol) {
			loginFormVo.isSelectProtocolError = true;
			haveError = true;
			if (showProtocolToast) {
				useMessage().error(t('addPsg.qingxuanze') + t('login.tiaokuan'));
			}
		} else {
			loginFormVo.isSelectProtocolError = false;
		}
	}
	if (!haveError) {
		return true;
	}
}
function handleViews() {
	loginHeaderRef.isViews = !loginHeaderRef.isViews;
	if (loginHeaderRef.isViews) {
		loginHeaderRef.passwordType = 'type';
	} else {
		loginHeaderRef.passwordType = 'password';
	}
}
function currentLoginDataFun(param: string) {
	currentSource.value = param;
}
defineExpose({ currentLoginDataFun });
</script>

<style lang="scss" scoped>
.tt_main {
	z-index: 999;
}
</style>
